<!-- Employee Action Modal -->
<div class="modal-overlay" *ngIf="isVisible && employee" (click)="close()">
    <div class="modal-dialog employee-action-modal" (click)="stopPropagation($event)">
        <div class="modal-content">
            <!-- Modal Header -->
            <div class="modal-header">
                <h2 class="modal-title">
                    <i class="fa fa-user"></i>
                    {{ employee.name || employee.email }}
                </h2>
                <button type="button" class="modal-close" (click)="close()" aria-label="Close modal">
                    <i class="fa fa-times"></i>
                </button>
            </div>

            <!-- Modal Body -->
            <div class="modal-body">
                <div class="action-list" *ngIf="availableActions.length > 0">
                    <button *ngFor="let action of availableActions"
                            class="action-btn"
                            [class.disabled]="action.disabled"
                            [class.action-danger]="action.variant === 'danger'"
                            [title]="action.disabledReason || ''"
                            (click)="selectAction(action)"
                            [disabled]="action.disabled"
                            [attr.aria-disabled]="action.disabled">
                        <i [class]="action.icon"></i>
                        <span class="action-label">{{ action.label }}</span>
                        <span class="disabled-indicator" *ngIf="action.disabled && action.disabledReason">
                            <i class="fa fa-info-circle"></i>
                        </span>
                    </button>
                </div>

                <div class="no-actions" *ngIf="availableActions.length === 0">
                    <i class="fa fa-info-circle"></i>
                    <p>No actions available for this employee.</p>
                </div>
            </div>
        </div>
    </div>
</div>
